import { Link } from 'react-router-dom';
import { StaggerList, ListItem } from '../ui/Motion.js';
import { GraduationCap, ChevronRight } from 'lucide-react';
import { SkeletonCard } from '../ui/SkeletonCard.js';
import type { CourseResponse } from '@xdface-vault/shared';

interface CoursesSectionProps {
  courses: CourseResponse[];
  isLoading: boolean;
}

export function CoursesSection({ courses, isLoading }: CoursesSectionProps) {
  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-sm font-semibold text-[var(--color-text)] uppercase tracking-wider">
          Mis cursos
        </h2>
        <Link to="/courses" className="text-xs text-xd-action hover:underline">
          Ver todos
        </Link>
      </div>
      {isLoading ? (
        <SkeletonCard />
      ) : courses.length === 0 ? (
        <div className="rounded-xl border border-dashed border-[var(--color-border)] bg-[var(--color-surface)] p-8 text-center">
          <GraduationCap className="mx-auto w-10 h-10 text-[var(--color-text-muted)] mb-3" />
          <p className="font-medium text-[var(--color-text)]">Sin cursos todavía</p>
          <p className="mt-1 text-sm text-[var(--color-text-muted)]">
            Creá tu primer curso o importá uno
          </p>
          <Link
            to="/courses/new"
            className="mt-4 inline-flex items-center gap-2 rounded-lg border border-xd-action px-4 py-2 text-sm font-medium text-xd-action hover:bg-xd-action/10 transition-colors"
          >
            Crear curso
          </Link>
        </div>
      ) : (
        <StaggerList className="space-y-2">
          {courses.slice(0, 4).map((course) => (
            <ListItem key={course.id}>
              <Link
                to={`/courses/${course.id}`}
                className="flex items-center gap-4 rounded-xl border border-[var(--color-border)] bg-[var(--color-surface)] px-4 py-3 hover:border-xd-action/30 hover:shadow-sm transition-all"
              >
                <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-xd-action/10">
                  <GraduationCap className="h-4 w-4 text-xd-action" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-[var(--color-text)] truncate">
                    {course.title}
                  </p>
                  <p className="text-xs text-[var(--color-text-muted)]">
                    {course.lessonsCount} lección{course.lessonsCount !== 1 ? 'es' : ''}
                  </p>
                </div>
                <ChevronRight className="h-4 w-4 text-text-subtle shrink-0" />
              </Link>
            </ListItem>
          ))}
        </StaggerList>
      )}
    </div>
  );
}
